import React from "react";
import  carousalstyles from "./carousalstyles.module.css"
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import JoinedHands from "../../assets/Images/joined-hands.jpeg"
import Collect from "../../assets/Images/collect-directly.jpeg"
import Orders from "../../assets/Images/orders-across-ka.jpeg"
import Deliver from "../../assets/Images/fresh-delivery.jpeg"
import PayFarmers from "../../assets/Images/pay-farmers.jpeg"


const Carousal = () => {
  return (
<>
<div className={carousalstyles.wrapper}>
<div className="slider-container">
        <Carousel autoPlay className="carousel-style" infiniteLoop={true} showArrows={true} showThumbs={false} showStatus={false}>
          <div className="slider-item-div">
           <img alt="JoinedHands" src={JoinedHands} />
          </div>
          <div className="slider-item-div">
           <img alt="Collect" src={Collect} />
          </div>
          <div className="slider-item-div">
           <img alt="Orders" src={Orders} />
          </div>
          <div className="slider-item-div">
           <img alt="Delivery" src={Deliver} />
          </div>
          <div className="slider-item-div">
           <img alt="PayFarmers" src={PayFarmers} />
          </div>
        </Carousel>
      </div>
      </div>

</>
  )
}

export default Carousal

